import { useCallback } from 'react';
import axiosPrivate from 'config/axiosPrivate';

export const useAdminClientTextSave = ({
  redactionData,
  initialHtmlContent,
  initialTextContent,
  actualTextContent,
  actualHtmlContent,
  actualTextWordCount,
  initialTextWordCount,
  combinedKeywords,
  keyword,
  metaDescriptionTag,
  textTitle,
  titleTag,
  url,
  textType,
  stuffedKeywords,
  websites,
  initialStuffedKeywords,
  analyseResult,
  redactionId,
  setConfirmation,
  setActualTextContent,
  setActualHtmlContent,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setErrorSuccess,
  t,
  websiteId,
  aiAgentId,
  aiAgentModel,
  projectId,
  currentContentScore,
  currentSemanticGap,
}) => {
  const handleSave = useCallback(async (action = 'manualDraft', overrides = {}) => {
    try {
      const payload = {
        keyword: keyword || '',
        url: url || '',
        titleTag: titleTag || '',
        metaDescriptionTag: metaDescriptionTag || '',
        contentScore: currentContentScore || redactionData?.contentScore || null,
        actualTextContent: overrides.actualTextContent !== undefined ? overrides.actualTextContent : (actualTextContent || ''),
        initialTextContent: initialTextContent || '',
        actualHtmlContent: overrides.actualHtmlContent !== undefined ? overrides.actualHtmlContent : (actualHtmlContent || ''),
        initialHtmlContent: initialHtmlContent || '',
        activeInitialText: redactionData?.activeInitialText || true,
        type: textType || 'NON_TRANSLATED',
        numberWords: actualTextWordCount || 0,
   
        internalLinking: websites || '',
        aiAgentId: aiAgentId || '',
      };

      console.log('💾 Sauvegarde AdminClient:', { action, payload, hasId: !!redactionId });

      let response;

      const isNewText = !redactionId || (!redactionData?.actualTextContent && !redactionData?.actualHtmlContent);

      if (isNewText) {

        console.log('📝 Création d\'un nouveau texte');
        response = await axiosPrivate.post(`/texts/external/${projectId}`, payload);
      } else {

        console.log('✏️ Mise à jour du texte existant');
        response = await axiosPrivate.put(`/texts/external/${redactionId}`, payload);
      }

      console.log('✅ Réponse API:', response.data);

      setErrorSuccessMsg(t('Texte sauvegardé avec succès'));
      setIsSuccess(true);
      setErrorSuccess(true);

      return response.data;
    } catch (error) {
      console.error('❌ Erreur lors de la sauvegarde:', error);
      setErrorSuccessMsg(error?.response?.data?.message || t('Erreur lors de la sauvegarde'));
      setIsSuccess(false);
      setErrorSuccess(true);
      throw error;
    }
  }, [
    redactionId,
    redactionData,
    keyword,
    url,
    titleTag,
    metaDescriptionTag,
    actualTextContent,
    actualHtmlContent,
    initialTextContent,
    initialHtmlContent,
    websites,
    actualTextWordCount,
    textType,
    websiteId,
    aiAgentId,
    aiAgentModel,
    projectId,
    currentContentScore,
    currentSemanticGap,
    setErrorSuccessMsg,
    setIsSuccess,
    setErrorSuccess,
    t,
  ]);

  const isTextFieldDisabled = false;

  return {
    handleSave,
    isTextFieldDisabled,
  };
};
